"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Task = void 0;
var lesson_1 = require("./lesson");
var account_1 = require("../account");
var meeting_1 = require("./meeting/meeting");
var game_1 = require("../game");
var Task = /** @class */function () {
  function Task(values) {
    if (values === void 0) {
      values = {};
    }
    var properties = ['id', 'assigned_to_user_id', 'assigned_by_user_id', 'done_at', 'assigned_at', 'due_date_at', 'content_id', 'meeting_id', 'game_id'];
    var instance = this;
    properties.forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
    });
    if ('content' in values) {
      instance.content = new lesson_1.Lesson(values.content);
    }
    if ('assigned_to_user' in values) {
      instance.assigned_to_user = new account_1.User(values.assigned_to_user);
    }
    if ('assigned_by_user' in values) {
      instance.assigned_by_user = new account_1.User(values.assigned_by_user);
    }
    if ('meeting' in values) {
      instance.meeting = new meeting_1.Meeting(values.meeting);
    }
    if ('game' in values) {
      instance.game = new game_1.Game(values.game);
    }
  }
  Object.defineProperty(Task.prototype, "is_done", {
    /** выполнено ? */
    get: function () {
      return !!this.done_at;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Task.prototype, "is_done_in_time", {
    /** выполнено вовремя ? */
    get: function () {
      return this.due_date_at ? this.is_done && this.done_at <= this.due_date_at : true;
    },
    enumerable: false,
    configurable: true
  });
  return Task;
}();
exports.Task = Task;
